<template>
    <div>
		<ReFileUpload 
        v-model="files"
        :type="'file'"
        :multiple="true"
        :formId="typeof service_id == 'undefined' || service_id == '' ?'fileupload_01'+'_'+Math.random():'fileupload_'+service_id+'_'+Math.random()"
        acceptMime="*/*"
        :uploadApi="uploadApi"
        :delApi="delApi"
        :src_filenames="src_filenames"
        v-on:change="OnUploadFile"
        @removeFile="onFileRemove"
    />        
    </div>
</template>
<script>
import ReFileUpload from 'src/our_components/ReFileUpload.vue';
export default {
    components: {
        ReFileUpload
    },
    data(){
        return{
            isload: false,
            data: null,
            uploadApi: {'apiMethod':'UniUpload', 'apiParam':{'obj':'FileUpload','flt':{'type':'service_files','service_id':this.service_id}}},
            delApi: {'apiMethod':'document_DEL','apiParam':{'obj':'services','flt':{'id':this.id, 'service_id':this.service_id}}},
            files:[],
            src_filenames:[],
            strFilePath:'/DATA/services/file/',
        }
    },
    props:{
        service_id:{
            type: Number,
            required: true,
        },
        show: {
            type: Boolean,
            default: false,
        }
    },
    watch:{
        show(val){
            if(val==true && ! this.isload){
                this.load();
            }
        }
    },
    methods:{
        async load(){
            try{
                this.isload = true;
                const res = await this.$GVO.Api.services.documents_get({flt:{id: this.service_id}});
                this.buildData(res.data);
            }catch(e){
                console.error(e);
            }
        },
        buildData(data){
            this.data = data;
            let masFilePaths = [];
            let src_filenames = [];
            if(data.length > 0){
                for (let i = 0; i < data.length; i++) {
                    masFilePaths.push(this.strFilePath + data[i].filename);
                    let src_filename = data[i].filename;
                    if(data[i].src_filename!='') src_filename = data[i].src_filename;
                    src_filenames.push(src_filename);
                }
                // this.state.isFiles = true;
            }
            // this.state.iFileCount = masFilePaths.length;
            // if(this.state.iFileCount<=0)this.state.isFiles = false;
            this.files = masFilePaths;  
            this.src_filenames = src_filenames;  
        },
        OnUploadFile(objUpload){
            // console.log('objupload',{data:objUpload});
            if(typeof objUpload == 'string' && objUpload == ''){
                this.buildData([]);
                return;
            }
            if(objUpload == null) return false;
            if(typeof objUpload.selfObj != 'undefined'){
                if(!this.$GVO.isEmpty(objUpload.selfObj.uploadApi)){
                    // this.bUploading=true;
                    // const objIndex = objUpload.formId.match(/[0-9/.]+/)[0];
                    this.$GVO.UploadFile(objUpload.formId, objUpload.selfObj.uploadApi.apiMethod, objUpload.selfObj.uploadApi.apiParam)
                        .then(objApi => {
                            //console.log(objApi);
                            if(objApi.success){
                                for (let i = 0; i < objApi.data.length; i++) {
                                    this.files.push(objApi.data[i].fullpath);
                                    this.src_filenames.push(objApi.data[i].src_filename);
                                }
                                this.load();
                            }else{
                                // console.log(objApi.msg);
                                this.$GVO.showAlert('Загрузка файлов',objApi.msg);
                            }
                            // this.bUploading=false;
                        })
                        .catch(errorObjApi => 	{  
                            console.error(errorObjApi); 
                            // this.bUploading=false;
                        });
                }
            }
        },
        async onFileRemove(index, value){
            const file = this.data[index];
            if(file.link!=value) {
                alert('Ошикба удаления файла');
                return;
            }
            // console.log('REMOVE', index, value, this.data[index]);
            try{
                const res = await this.$GVO.Api.services.document_DEL({flt:file});
                if(res.success===true){
                    let data = [...this.data];
                    data.splice(data.indexOf(file),1);
                    this.buildData(data);
                }
                // console.log(res);
            }catch(e){
                console.error(e);
            }
        }
    },
    mounted(){
        if(this.show==true) this.load();
    }
}
</script>